export const rolesRoutes = [
    {
      role: "IT",
      allowedRoutes: ["*"]
    },
    {
      role: "pbiQuinquenalManager",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/",
        "/modules/records",
        "/modules/records/",
        "/modules/records/quinquennial",
        "/modules/records/quinquennial/",
        "/modules/reports",
        "/modules/reports/",
      ]
    },
    {
      role: "Coordinador",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/",
        "/modules/catalogs",
        "/modules/catalogs/",
        "/modules/reports",
        "/modules/reports/",
        "/modules/catalogs/internal-orders",
        "/modules/catalogs/internal-orders/",
        "/modules/catalogs/activities",
        "/modules/catalogs/activities/",
        "/modules/catalogs/zones",
        "/modules/catalogs/zones/",
        "/modules/reports/consolidado-forestal",
        "/modules/reports/consolidado-forestal/",
      ]
    },
    {
      role: "RRHH",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/",
        "/modules/catalogs",
        "/modules/catalogs/",
        "/modules/reports",
        "/modules/reports/",
        "/modules/catalogs/employees",
        "/modules/catalogs/employees/",
        '/modules/catalogs/groups',
        "/modules/catalogs/groups/",
        '/modules/catalogs/absence-reasons',
        "/modules/catalogs/absence-reasons/",
        '/modules/catalogs/cost-centers',
        '/modules/catalogs/cost-centers/',
        '/modules/reports/labores-empleados',
        '/modules/reports/labores-empleados/',
        '/modules/reports/reporte-asistencia',
        '/modules/reports/reporte-asistencia/'
      ]
    },
    {
      role: "Aprobador",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/",
        "/modules/records",
        "/modules/records/",
        "/modules/reports",
        "/modules/reports/",
        '/modules/records/activity-log',
        '/modules/records/activity-log/',
        '/modules/records/activity-log/*',
        '/modules/records/attendance-log',
        '/modules/records/attendance-log/',
        '/modules/records/attendance-log/*',
        '/modules/records/approvals',
        '/modules/records/approvals/',
        "/modules/reports/consolidado-forestal",
        '/modules/reports/consolidado-forestal/',
      ]
    },
    {
      role: "Mayordomo",
      allowedRoutes: [
        "/", //home
        "/modules",
        "/modules/",
        "/modules/records",
        "/modules/records/",
        '/modules/records/activity-log',
        '/modules/records/activity-log/',
        '/modules/records/activity-log/*',
        '/modules/records/attendance-log',
        '/modules/records/attendance-log/',
        '/modules/records/attendance-log/*',
        //'/modules/records/labor-entry',
        //'/modules/records/labor-entry/',
      ]
    },
    {  allRoutesForReferenceOnly: [
        "/", //home
        "/modules",
        "/modules/",
        "/modules/records",
        "/modules/records/",
        "/modules/reports",
        "/modules/reports/",
        "/modules/catalogs",
        "/modules/catalogs/",
        '/modules/records/activity-log',
        '/modules/records/activity-log/',
        '/modules/records/activity-log/*',
        '/modules/records/attendance-log',
        '/modules/records/attendance-log/',
        '/modules/records/attendance-log/*',
        '/modules/records/labor-entry',
        '/modules/records/labor-entry/',
        '/modules/records/approvals',
        "/modules/records/approvals/",
        "/modules/records/quinquennial",
        "/modules/records/quinquennial/",
        '/modules/reports/labores-empleados',
        "/modules/reports/labores-empleados/",
        '/modules/reports/reporte-asistencia',
        '/modules/reports/reporte-asistencia/',
        "/modules/reports/consolidado-forestal",
        '/modules/reports/consolidado-forestal/',
        "/modules/catalogs/internal-orders",
        '/modules/catalogs/internal-orders/',
        "/modules/catalogs/zones",
        '/modules/catalogs/zones/',
        "/modules/catalogs/activities",
        '/modules/catalogs/activities/',
        "/modules/catalogs/approvers",
        '/modules/catalogs/approvers/',
        "/modules/catalogs/processes",
        '/modules/catalogs/processes/',
        "/modules/catalogs/subprocesses",
        '/modules/catalogs/subprocesses/',
        "/modules/catalogs/employees",
        '/modules/catalogs/employees/',
        "/modules/catalogs/groups",
        '/modules/catalogs/groups/',
        "/modules/catalogs/absence-reasons",
        '/modules/catalogs/absence-reasons/',
        '/modules/catalogs/cost-centers',
        '/modules/catalogs/cost-centers/',
        "/modules/catalogs/users",
        '/modules/catalogs/users/',
        "/modules/catalogs/roles",
        '/modules/catalogs/roles/'
      ]
    }
  ]